import { useRouteLoaderData } from 'react-router';

export const useTypedRouteLoaderData = <T extends object>(routeId: string) => {
  return useRouteLoaderData(routeId) as T;
};
